const financeRoutes = [
  {
    path: '/finance',
    component: () => import('@/layouts/main/archistar/Main.vue'),
    children: [
      {
        path: 'daily-transaction-history',
        name: 'daily-transaction-history',
        component: () => import('@/components/archistar/table/FinanceTable.vue'),
        props: {
          scope: 'finance.dailyTransactionHistory'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Finance'
            },
            {
              title: 'Transactions',
              active: true
            }
          ],
          pageTitle: 'Daily Transaction History',
          rules: [
            {
              resource: 'finance reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'core-logic-company-report',
        name: 'core-logic-company-report',
        component: () => import('@/components/archistar/table/table_withDate.vue'),
        props: {
          scope: 'finance.coreLogicCompanyReport'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Finance'
            },
            {
              title: 'Transactions',
              active: true
            }
          ],
          pageTitle: 'Core Logic Company Report',
          rules: [
            {
              resource: 'finance reports',
              rule: 'read'
            }
          ]
        }
      },
      {
        path: 'nearmap-company-report',
        name: 'nearmap-company-report',
        component: () => import('@/components/archistar/table/table_withDate.vue'),
        props: {
          scope: 'finance.nearmapCompanyReport'
        },

        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/'
            },
            {
              title: 'Finance'
            },
            {
              title: 'Transactions',
              active: true
            }
          ],
          pageTitle: 'Nearmap Company Report',
          rules: [
            {
              resource: 'finance reports',
              rule: 'read'
            }
          ]
        }
      }
    ]
  }
];

export default financeRoutes;
